<script>
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	let {
		withDefaultDescription = false,
		titleString = null,
		title,
		description,
		footer,
	} = $props();
</script>

<Section backgroundColor="white">
	<h2>{titleString}</h2>
	<div class="flex flex-col items-center gap-y-4">
		<!-- heading -->
		<p
			class="flex flex-col text-[clamp(1.25rem,6vw,2.2rem)] leading-none font-bold uppercase"
		>
			{#if title}{@render title()}{:else}
				<span class="max-w-[28ch]"
					>Noise reduction compared to a single-pane window</span
				>
			{/if}
		</p>

		<ul
			class="text-indow-white mb-4 grid list-none items-center justify-items-center gap-10 sm:px-2 md:grid-cols-[1fr_0.65fr]"
		>
			<!-- circle -->
			<li class="flex w-full flex-col gap-y-4">
				<p
					class="bg-indow-blue !text-indow-white !mb-0 flex aspect-square items-center
						justify-center rounded-full px-8 text-[clamp(2rem,5vmax,5rem)] leading-none shadow-[inset_0px_0px_0px_0.35em_hsl(187,58%,80%)]"
				>
					50-70%
				</p>
				<p
					class="text-indow-blue text-center text-[clamp(1rem,5vw,2rem)] font-bold uppercase"
				>
					Indow
				</p>
			</li>

			<!-- circle -->
			<li class="flex w-full flex-col items-center gap-y-4">
				<p
					class="bg-indow-grey-dark !text-indow-white !mb-0 flex aspect-square w-1/2 items-center justify-center rounded-full text-[clamp(1.5rem,2vmax,3rem)]"
				>
					25%
				</p>
				<p
					class="text-indow-grey-dark max-w-[17ch] text-center text-[clamp(1rem,4vw+1px,1.4rem)] leading-none font-bold uppercase"
				>
					Replacement Windows
				</p>
			</li>
		</ul>

		<!-- description -->
		{#if description}{@render description()}{:else if withDefaultDescription}
			<p
				class="!text-indow-blue !mt-8 max-w-[30ch] text-[clamp(0.975rem,4vw+0.1rem,1.85rem)] leading-none font-bold uppercase sm:mt-0"
			>
				Indow inserts hush outside noise to a whisper.
			</p>
			<p class="mt-4">
				<a href="/solutions/noise-performance/"
					>Explore complete performance data here.</a
				>
			</p>
		{/if}
	</div>
	<!-- footer -->
	{#if footer}{@render footer()}{:else}
		<p class="text-xs italic">
			*We want to ensure our inserts help solve your noise problem. Overall
			noise reduction depends on the amount of noise coming through your walls,
			ceilings, floors, doors, and existing windows. Noise reduction will be
			less when placed over double-pane windows. Read our full <a
				href="/noise-disclaimer">Noise Reduction Sheet</a
			> to learn more.
		</p>
	{/if}
</Section>
